import * as React from "react";
import Svg, { Path, Rect } from "react-native-svg";

function SvgComponent() {
  return (
    <Svg
      fill="#000"
      width={60}
      height={60}
      viewBox="0 0 24 24"
      data-name="Line Color"
    >
      <Path
        d="M21 7h-2v2h2zm0 6h-2v2h2zM11 8a2 2 0 102 2 2 2 0 00-2-2zm3 7a3 3 0 00-3-3 3 3 0 00-3 3v1h6z"
        fill="none"
        stroke="#2ca9bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <Rect
        x={3}
        y={3}
        width={16}
        height={18}
        rx={1}
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </Svg>
  )
}

export default SvgComponent;